import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { ListItemNode, ListNode } from '@lexical/list';
import { CodeHighlightNode, CodeNode } from '@lexical/code';
import { LinkNode, AutoLinkNode } from '@lexical/link';
import { TableNode, TableCellNode, TableRowNode } from '@lexical/table';
import { MarkNode } from '@lexical/mark';
import { SuggestionNode } from '../nodes/SuggestionNode';
import { SuggestionMarkNode } from '../nodes/SuggestionMarkNode';
import { HtmlNode } from '../nodes/HtmlNode';
import { LineBreakNode } from 'lexical';
import { InitialConfigType } from '@lexical/react/LexicalComposer';
import { ImageNode } from '../nodes/ImageNode';
import { PageBreakNode } from '../nodes/PageBreakNode';

const nodes: InitialConfigType['nodes'] = [
  HeadingNode,
  QuoteNode,
  ListNode,
  ListItemNode,
  LineBreakNode,
  CodeNode,
  CodeHighlightNode,
  LinkNode,
  AutoLinkNode,
  TableNode,
  TableCellNode,
  TableRowNode,
  MarkNode,
  SuggestionNode,
  SuggestionMarkNode,
  HtmlNode,
  ImageNode,
  PageBreakNode,
];

export default nodes;
